import commonAlert from '../components/tipsAlert'
import Vue from 'vue'
const SwapStage = {
  SwapStageGetTokenList: 1, // the stage of get the token list
  SwapStageGetDepositInfo: 2, // the stage of get deposit info
  SwapStageSwap: 3 // the state of swap
}

const SwapType = {
  SwapTypeUnknown: -1, // unknown swap type
  SwapTypeErc20ToBep2: 1, // Erc20 to Bep2
  SwapTypeErc20ToMainNet: 2, // Erc20 to COS main net
  SwapTypeBep2ToErc20: 3, // Bep2 to Erc20
  SwapTypeBep2ToMainNet: 4, // Bep2 to mainNet
  SwapTypeMainNetToErc20: 5, // mainNet to Erc20
  SwapTypeMainNetToBep2: 6, // mainNet to Bep2
  SwapTypeBep20ToMainNet: 7, // Bep20 to mainNet
  SwapTypeMainNetToBep20: 8 // mainNet to Bep20

}

const TokenType = {
  TokenTypeUnknown: -1, // unknown token type
  TokenTypeErc20: 1, // erc20 token
  TokenTypeBep2: 2, // bep2 token
  TokenTypeCosMainNet: 3, // cos main net token
  TokenTypeBep20: 4 // bep20 token
}

const SwapResult = {
  SwapResultFail: 0, // swap fail
  SwapResultSuccess: 1, // swap success
  SwapResultNotNeedTransfer: 2 // swap success but No final transfer required
}

const SwapChargeStatus = {
  SwapChargeStatusNotFree: 0, // deduct fee
  SwapChargeStatusFree: 1 // free
}

const netErrorCode = {
  netErrorCodeSystemError: 500,
  netErrorCodeInternalServerError: 600,
  netErrorCodeSwapAddressInvalid: 602,
  netErrorCodeSwapAddressNotExist: 603,
  netErrorCodeInvalidSwapType: 605,
  netErrorCodeInvalidExchangeMemo: 608
}

const languageType = {
  languageTypeTW: 'zh-tw',
  languageTypeCN: 'zh-cn',
  languageTypeEn: 'en',
  languageTypeJa: 'ja',
  languageTypeKo: 'ko',
  languageTypeVietnam: 'vi',
  languageTypePortugal: 'pt-br',
  languageTypeRussian: 'ru'
}

const swapTypeKey = 'SwapType'
const tokenTypeKey = 'Type'
const memoKey = 'Memo'
const addressKey = 'Address'
const resultStatusKey = 'Status'
const swapAmountKey = 'SwapAmount'
const depositAmountKey = 'DepositAmount'
const depositTxHashKey = 'DepositHash'
const resSenderKey = 'From'
const resReceiverKey = 'To'
const resTxHashKey = 'TxHash'
const isFreeKey = 'IsFree'
const feeDescKey = 'FeeDesc'
const statusKey = 'Status'
const infoKey = 'Info'
const msgKey = 'Msg'
const swapAddressKey = 'swapAddress'
const exChangeMemo = 'exChangeMemo'

export default {
  SwapStage,
  TokenType,
  SwapType,
  SwapResult,
  swapTypeKey,
  tokenTypeKey,
  memoKey,
  addressKey,
  resultStatusKey,
  depositAmountKey,
  depositTxHashKey,
  swapAmountKey,
  resSenderKey,
  resReceiverKey,
  resTxHashKey,
  isFreeKey,
  feeDescKey,
  SwapChargeStatus,
  statusKey,
  infoKey,
  msgKey,
  swapAddressKey,
  exChangeMemo,
  netErrorCode,
  languageType,

  /*
   *check is swap erc20 to bep2 or main net cos
   */
  checkIsErc20Swap (swapType) {
    return (swapType === SwapType.SwapTypeErc20ToBep2 || swapType === SwapType.SwapTypeErc20ToMainNet)
  },

  /*
   check is swap bep2 to erc20 or main net cos
   */
  checkIsBep2Swap (swapType) {
    return (swapType === SwapType.SwapTypeBep2ToMainNet || swapType === SwapType.SwapTypeBep2ToErc20)
  },

  /*
   *check is swap main net cos to erc20 or bep2 or bep20
   */
  checkIsCosMainNetSwap (swapType) {
    return (swapType === SwapType.SwapTypeMainNetToBep2 || swapType === SwapType.SwapTypeMainNetToErc20 || swapType === SwapType.SwapTypeMainNetToBep20)
  },

  checkIsBep20Swap (swapType) {
    return swapType === SwapType.SwapTypeBep20ToMainNet
  },

  /*
   * check is swap main net cos or bep2 to erc20
   */
  checkIsSwapToErc20 (swapType) {
    return (swapType === SwapType.SwapTypeMainNetToErc20 || swapType === SwapType.SwapTypeBep2ToErc20)
  },

  /*
   check is swap main net cos or erc20 to bep2
   */
  checkIsSwapToBep2 (swapType) {
    return (swapType === SwapType.SwapTypeErc20ToBep2 || swapType === SwapType.SwapTypeMainNetToBep2)
  },

  /*
   * check is swap bep2 or erc20 to main net cos
   */
  checkIsSwapToCosMainNet (swapType) {
    return (swapType === SwapType.SwapTypeBep2ToMainNet || swapType === SwapType.SwapTypeErc20ToMainNet || swapType === SwapType.SwapTypeBep20ToMainNet)
  },

  /*
   check is swap main net cos to bep20
   */
  checkIsSwapToBep20 (swapType) {
    return swapType === SwapType.SwapTypeMainNetToBep20
  },

  checkIsNotNullObj (obj) {
    if (obj != null && typeof obj !== 'undefined') {
      return true
    }
    return false
  },

  checkIsDev () {
    return process.env.NODE_ENV !== 'production'
  },

  showAlert (title, desc) {
    let TipsAlert = Vue.extend(commonAlert)
    let alert = new TipsAlert()
    let config = {}
    config.title = title
    config.content = desc
    alert.showCommonAlert(config)
  },

  /*
   * check if bnb address is the exchange address
   */
  checkIsBnbExchangeAddr (addr) {
    if (!this.checkIsDev()) {
      if (addr === 'bnb1p89xmrejmqpwmkye4z2pwtrw49n2vykf3nax33' ||
        addr === 'bnb136ns6lfw4zs5hg4n85vdthaad7hq5m4gtkgf23' ||
        addr === 'bnb16wdyjpl7qzs4hmmt3fpp6fsd63ew385phkqw48' ||
        addr === 'bnb153qsnglpzc3zdfcu6ghnqeyx9vzuaf258lu5l9' ||
        addr === 'bnb165q9dz39mqh789zuuuqwkv22plut6f4nzy9jc9') {
        return true
      }
    } else if (addr === 'tbnb1ewag6r47hdw8lalxln0pme3qks5p7nqh98cw80') {
      return true
    }

    return false
  },

  isValidBnbExchangeMemo (s) {
    return /^\d+$/.test(s)
  },

  checkIsCosMainNetExchangeAddr (addr) {
    if (!this.checkIsDev()) {
      if (addr === 'bitrueprodcos') {
        return true
      }
    } else if (addr === 'bitruetest') {
      return true
    }

    return false
  },

  checkIsSupportLanguage (lCode) {
    for (let i in languageType) {
      if (lCode === languageType[i]) {
        return true
      }
    }
    return false
  },

  serviceFee (swapType) {
    if (this.checkIsErc20Swap(swapType)) {
      return 500
    } else if (this.checkIsBep20Swap(swapType)) {
      return 10
    } else if (swapType === SwapType.SwapTypeMainNetToBep20) {
      return 10
    }
    return 0
  }

}
